import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from 'react-helmet-async';
import Header from "./components/Header";
import Footer from "./components/Footer";
import LocalBusinessSchema from "./components/LocalBusinessSchema";
import ScrollToTop from "./components/ScrollToTop";
import ScrollToTopOnMount from "./components/ScrollToTopOnMount";
import ScrollReveal from "./components/ScrollReveal";
import MobileStickyCTA from "./components/MobileStickyCTA";
import TrustStrip from "./components/TrustStrip";
import Home from "./pages/Home";
import LeCentre from "./pages/LeCentre";
import Consultations from "./pages/Consultations";
import Equipe from "./pages/Equipe";
import RendezVous from "./pages/RendezVous";
import Contact from "./pages/Contact";
import Cabinets from "./pages/Cabinets";
// Thematic pages
import NutritionHormonale from "./pages/NutritionHormonale";
import PertePoidsHormonale from "./pages/PertePoidsHormonale";
import SOPKAlimentation from "./pages/SOPKAlimentation";
import PremenopauseMetabolisme from "./pages/PremenopauseMetabolisme";
import SanteCardiovasculaire from "./pages/SanteCardiovasculaire";
import EquilibreEmotionnel from "./pages/EquilibreEmotionnel";
import HypnosePertePoids from "./pages/HypnosePertePoids";
import HypnopraxieVevey from "./pages/HypnopraxieVevey";
import NutritionnisteVeveyClarens from "./pages/NutritionnisteVeveyClarens";
import PertePoidsVeveyClarens from "./pages/PertePoidsVeveyClarens";
// Symptom-focused SEO pages
import RetentionEau from "./pages/RetentionEau";
import CompulsionsSucre from "./pages/CompulsionsSucre";
// New SEO pages — fertility & rééquilibrage
import FertiliteNutrition from "./pages/FertiliteNutrition";
import ReequilibrageAlimentaire from "./pages/ReequilibrageAlimentaire";
// Prestation detail pages
import PrestationConsultation from "./pages/PrestationConsultation";
import PrestationHypnopraxie from "./pages/PrestationHypnopraxie";
import ResistanceInsuline from "./pages/ResistanceInsuline";
// Blog
import Blog from "./pages/Blog";
import BlogPost from "./pages/BlogPost";
// Glossaire
import Glossaire from "./pages/Glossaire";
// Legal
import MentionsLegales from "./pages/MentionsLegales";
import NotFound from "./pages/NotFound";

// Import custom styles
import "./styles/colors.css";
import "./styles/typography.css";
import "./styles/components.css";

function App() {
  return (
    <HelmetProvider>
      <div className="App">
        <BrowserRouter>
          <LocalBusinessSchema />
          <ScrollToTopOnMount />
          <ScrollReveal />
          <ScrollToTop />
          <Header />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/le-centre" element={<LeCentre />} />
            <Route path="/consultations" element={<Consultations />} />
            <Route path="/equipe" element={<Equipe />} />
            <Route path="/cabinets" element={<Cabinets />} />
            <Route path="/rendez-vous" element={<RendezVous />} />
            <Route path="/contact" element={<Contact />} />
            {/* Thematic pages */}
            <Route path="/nutrition-hormonale" element={<NutritionHormonale />} />
            <Route path="/perte-poids-hormonale" element={<PertePoidsHormonale />} />
            <Route path="/sopk-alimentation" element={<SOPKAlimentation />} />
            <Route path="/premenopause-metabolisme" element={<PremenopauseMetabolisme />} />
            <Route path="/sante-cardiovasculaire" element={<SanteCardiovasculaire />} />
            <Route path="/equilibre-emotionnel" element={<EquilibreEmotionnel />} />
            <Route path="/hypnose-perte-de-poids-vevey-clarens" element={<HypnosePertePoids />} />
            <Route path="/hypnopraxie-vevey-montreux" element={<HypnopraxieVevey />} />
            <Route path="/nutritionniste-vevey-clarens" element={<NutritionnisteVeveyClarens />} />
            <Route path="/perte-de-poids-vevey-clarens" element={<PertePoidsVeveyClarens />} />
            <Route path="/retention-eau-jambes-lourdes" element={<RetentionEau />} />
            <Route path="/compulsions-sucre-soir" element={<CompulsionsSucre />} />
            <Route path="/fertilite-nutrition-femme" element={<FertiliteNutrition />} />
            <Route path="/reequilibrage-alimentaire-vevey-lausanne" element={<ReequilibrageAlimentaire />} />
            <Route path="/prestations/consultation-nutritionnelle" element={<PrestationConsultation />} />
            <Route path="/prestations/hypnopraxie" element={<PrestationHypnopraxie />} />
            <Route path="/resistance-insuline-nutrition" element={<ResistanceInsuline />} />
            {/* Blog */}
            <Route path="/blog" element={<Blog />} />
            <Route path="/blog/:slug" element={<BlogPost />} />
            {/* Glossaire */}
            <Route path="/glossaire" element={<Glossaire />} />
            {/* Legal */}
            <Route path="/mentions-legales" element={<MentionsLegales />} />
            {/* 404 */}
            <Route path="*" element={<NotFound />} />
          </Routes>
          <TrustStrip />
          <Footer />
          <MobileStickyCTA />
        </BrowserRouter>
      </div>
    </HelmetProvider>
  );
}

export default App;
